import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { LoadData } from './vehicle.actions';
import { VehicleState } from './vehicle.interfaces';

@Injectable()
export class VehicleEffects {
  
  loadData = createEffect(() => this.dataPersistence.fetch('LOAD_DATA', {
    run: (action: LoadData, state: VehicleState) => {
      return {
        type: 'DATA_LOADED',
        payload: {}
      };
    },

    onError: (action: LoadData, error) => {
      console.error('Error', error);
    }
  }));

  constructor(private actions: Actions, private dataPersistence: DataPersistence<VehicleState>) {}
}
